import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/$tenantSlug/_layout/offer/_layout")({
    component: () => <OfferLayout />,
    loader: async ({ context: { t } }) => ({
        breadcrumb: t("pages.offer.title"),
    }),
});

function OfferLayout() {
    return <Outlet />;
}
